function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useRef } from "react";
import { BottomSheet } from "sprout-ui-dom/dist/BottomSheet";
import { useHistory } from "react-router";
import { getItemUrl } from "sprout-lib";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { useNavigationListListContext } from "@sprout/list-navigation";
import { scrollPostIntoView } from "@sprout/client-components/dist/Post";
import useTopicPageCreatePost from "../graphql/mutations/useTopicPageCreatePost";
import TopicPageEditorPostDesktop from "./TopicPageEditorPostDesktop";
import TopicPageEditorPostMobile from "./TopicPageEditorPostMobile";
const TopicPageEditorPost = (props)=>{
    const { closeEditor , topicId , open , afterItemId , topicNodeId , context  } = props;
    const handleEscape = useCallback(()=>{
        closeEditor();
        return true;
    }, [
        closeEditor
    ]);
    const pendingRef = useRef(false);
    const showSnackbar = useSnackbar();
    const history = useHistory();
    const { setActiveItemId  } = useNavigationListListContext();
    const createPostMutation = useTopicPageCreatePost();
    const handleCreate = useCallback(({ routeToPost , text , link  })=>{
        if (pendingRef.current) return;
        // start of mutation
        pendingRef.current = true;
        closeEditor();
        /**
       * We do not allow empty post, i.e. post without description and link.
       * We are also not using `returnTextIfEmpty` from the parser, as we
       * do not want the link to appear in the description.
       */ if (!text.trim() && !link) {
            pendingRef.current = false;
            return;
        }
        const afterLastItem = afterItemId === undefined;
        const isLink = link !== null && link.startsWith("http");
        createPostMutation(_objectSpread({
            variables: {
                parentTopicId: topicId,
                // items_check6
                description: text || (link ? isLink ? null : link : ""),
                // items_check7
                url: isLink ? link : null,
                afterItemId,
                afterLastItem
            }
        }, context === "page" ? {
            context,
            topicNodeId: undefined
        } : {
            context,
            topicNodeId
        })).then((result)=>{
            var ref, ref1;
            const post = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.createItem) === null || ref1 === void 0 ? void 0 : ref1.item;
            if (post) {
                if (routeToPost) {
                    const url = getItemUrl(post);
                    history.push(url);
                } else {
                    scrollPostIntoView(post);
                    setActiveItemId(String(post.id));
                }
            }
        }).catch(()=>{
            showSnackbar.error();
        }).finally(()=>{
            pendingRef.current = false;
        });
    }, [
        afterItemId,
        closeEditor,
        context,
        createPostMutation,
        history,
        setActiveItemId,
        showSnackbar,
        topicId,
        topicNodeId, 
    ]);
    const handleEnter = useCallback(({ getStateAsText  })=>{
        const { link , text  } = getStateAsText();
        handleCreate({
            routeToPost: false,
            link,
            text
        });
        return true;
    }, [
        handleCreate
    ]);
    const handleSave = useCallback(({ getStateAsText  })=>{
        const { link , text  } = getStateAsText();
        handleCreate({
            routeToPost: true,
            link,
            text
        });
        return true;
    }, [
        handleCreate
    ]);
    const cancelButtonRef = useRef(null);
    const handleBlur = useCallback(({ getStateAsText  }, event)=>{
        if (event.relatedTarget === cancelButtonRef.current) return false;
        const { link , text  } = getStateAsText();
        handleCreate({
            routeToPost: false,
            link,
            text
        });
        return true;
    }, [
        handleCreate
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BottomSheet, {
                open: open === "mobile",
                unmountOnExit: true,
                children: /*#__PURE__*/ _jsx(TopicPageEditorPostMobile, {
                    topicId: topicId,
                    closeEditor: closeEditor,
                    onEscape: handleEscape,
                    onEnter: handleEnter,
                    onSave: handleSave
                })
            }),
            open === "desktop" && /*#__PURE__*/ _jsx(TopicPageEditorPostDesktop, {
                cancelButtonRef: cancelButtonRef,
                topicId: topicId,
                closeEditor: closeEditor,
                onEscape: handleEscape,
                onEnter: handleEnter,
                onSave: handleSave,
                onBlur: handleBlur
            })
        ]
    });
};
export default TopicPageEditorPost;
